import React, { useState } from 'react'
import { Button } from 'antd'
import gql from 'graphql-tag'
import { useFormContext } from '@/state/main-form/reducer'
import { useFormLlmInterfaceQuery } from './__gen'
import { AiChatbot } from '../../common/llm-interface/ai-chatbot'
import style from './index.module.sass'

gql`
	query formLlmInterface($formId: ID!) {
		form(id: $formId) {
			id
			llmInterface {
				id
			}
		}
	}
`

export const LlmInterfaceList = () => {
	const formContext = useFormContext()
	const { data, loading } = useFormLlmInterfaceQuery({
		variables: {
			formId: formContext.form.id,
		},
	})

	const [show, setShow] = useState(false)

	if (!data?.form?.llmInterface) {
		return null
	}

	return (
		<>
			{show ?
				<AiChatbot onClose={() => setShow(false)} />
			:	<Button onClick={() => setShow(!show)} className={style.aiSupportButton} type="primary" size="middle">
					AI Support
				</Button>
			}
		</>
	)
}
